import { useState } from 'react';
import type { SelectedTemplateInfo } from '../types';

export function SelectedTemplateRow({ template }: { template: SelectedTemplateInfo }) {
  const [open, setOpen] = useState(false);
  const hasDetails = !!(
    template.description ||
    template.optionSummary ||
    (template.dependsOn && template.dependsOn.length > 0)
  );
  return (
    <div className="pipeline-template-row" data-testid="pipeline-template-row">
      <div
        className={`pipeline-template-header${hasDetails ? ' clickable' : ''}`}
        onClick={hasDetails ? (e) => { e.stopPropagation(); setOpen(!open); } : undefined}
        style={hasDetails ? { cursor: 'pointer' } : undefined}
      >
        {hasDetails && <span className="step-expand-icon">{open ? '▾' : '▸'}</span>}
        <span className="pipeline-template-name">{template.displayName}</span>
        <span className="pipeline-template-category">{template.category}</span>
        {template.context && <span className="pipeline-template-context">{template.context}</span>}
      </div>
      {open && hasDetails && (
        <div className="pipeline-template-details">
          {template.description && (
            <div className="pipeline-template-description">{template.description}</div>
          )}
          {template.optionSummary && (
            <div className="pipeline-template-options">
              <span className="pipeline-template-options-label">Config options:</span>
              <span className="pipeline-template-options-value">{template.optionSummary}</span>
            </div>
          )}
          {template.dependsOn && template.dependsOn.length > 0 && (
            <div className="pipeline-template-depends">
              <span className="pipeline-template-options-label">Depends on:</span>
              <span className="pipeline-template-options-value">{template.dependsOn.join(', ')}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
